import React, { useEffect, useRef, useState } from "react";
import Header from "../components/global/Header";
import LeftNavbar from "../components/global/LeftNavbar";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Overview from "../components/campaign/campaign_detail/Overview";
import Reviewers from "../components/campaign/campaign_detail/Reviewers";
import Projects from "../components/campaign/campaign_detail/Projects";
import Tasks from "../components/campaign/campaign_detail/Tasks";
import Assets from "../components/campaign/campaign_detail/Assets";
import Discussion from "../components/campaign/campaign_detail/Discussion";
import { getDepartmentObject } from "../services/Util";
import { updateSourceFiles } from "../redux/reducers/SourceFilesSlice";
import { getAxiosResponse,postAxiosResponse,putAxiosResponse } from "../services/authApiRoutes/APImethods";
import AddExistingProjectToCampaign from "../components/campaign/campaign_detail/AddExistingProjectToCampaign";
import { transformBlankToNull } from "../services/Util";
import { RotatingLines } from "react-loader-spinner";
import {projectCreationStepFilter } from '../redux/reducers/ProjectCreationStepSlice';
import { campaignDetailDate } from "../services/Util";
import icons from "../icons";
import APIUrls from "../services/APIUrls";
import $ from "jquery";
import { updateTargetLanguage } from "../redux/reducers/CreateProjectTargetLanguageSlice";
import { updateSourceLanguage } from "../redux/reducers/CreateProjectSourceLanguageSlice";
import { departmentSelected } from "../redux/reducers/CreateProjectDepartmentSelectSlice";
import { updateProjectFollowers } from "../redux/reducers/ProjectInfoSlice";
import { updateInitializedProjectWorkflows } from "../redux/reducers/InitializedProjectWorkflowsSlice";
import { updateProjectInfoConfiguration } from "../redux/reducers/ProjectInfoConfigurationSlice";
import { updateProjectInfoValidation } from "../redux/reducers/ProjectInfoValidationSlice";
import { updateProjectInfo } from "../redux/reducers/ProjectInfoSlice";
import ProjectMembersSlice from "../redux/reducers/ProjectMembersSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { AppBar } from "@mui/material";
import { TourProvider } from "@reactour/tour";
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import "@reactour/popover/dist/index.css";
import steps from "../services/tourJson/campaign-details";
import { Breadcrumb } from "../components/dashboard/Breadcrumb";
import Constants from "../Constants";
import UnableToCompleteRequest from "../components/UnableToCompleteRequest";
import { handleError } from "../services/authApiRoutes/APImethods";
import { updateAsyncUploadAssetCompletedFiles, updateAsyncUploadAssetInProgressFiles, updateAsyncUploadAssetPendingFiles, updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors } from "../redux/reducers/AsyncAssetUploadSlice";
import { CrossIconForModal } from "../AppIcons";
import { updateBidRequestInfo } from "../redux/reducers/BidRequestSlice";
import { ConditionalBlock } from "../ConditionalBlock";
import { confirmAlert } from "react-confirm-alert";
export default function CampaignDetail() {
  const { t } = useTranslation();
  const translate = t;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [menuBtnFocus, setMenuBtnFocus] = useState(false);
  const [projectDeliveryStatus,setProjectDileveryStatus]=useState("")
  const [projectCount,setProjectCount]=useState(0)
  const [activityTaskId,setTaskId]=useState("")
  const [unreadDiscussionCount,setCount] = useState(0);
  const location = useLocation();
  const state = location.state;
  let intendedUseId;
  let department;
  const scrollRef = useRef(null);
  const hideModel = () => {
    document.body.classList.remove("modal-open");
    if(menuBtnFocus){
      $('.circle').trigger('focus')
        setMenuBtnFocus(false);
      } else {
      $('#showMoreCapaignDetail').trigger('focus')
    }
  };
  const hideProjectModel = () => {
    setOpenProj(false);
    hideModel();
    setTimeout(()=>{
      if(menuBtnFocus){
        $('.circle').trigger('focus')
        setMenuBtnFocus(false);
      } else {
        $('#showMoreCapaignDetail').trigger('focus')
      }
    },500)
  };
  const showModel = () => {
    document.body.classList.add("modal-open");
  };
  const reference1 = useRef(null);
  const reference2 = useRef(null);
  const campaignDetailRef = useRef(null)
  const [openProj, setOpenProj] = useState(false);
  const param = useParams();
  const openAddProjPopup = () => {
    setOpenProj(true);
    showModel();
    setMenuBtnFocus(true);
  };
  const existingProjectPopupHandling = (event) => {
    if (event.key === Constants.ESCAPE) {
      hideProjectModel();
      setTimeout(() => {
        $('.circle').trigger('focus');
      }, 500);
    }
  }
  useEffect(()=>{
    $('#cancelAddExistingProjectBtn').on('keydown', function(e){
      if(e.key === Constants.TAB && !e.shiftKey) {
        e.preventDefault();
        $('#ExistingProjectclosebtn').trigger('focus');
      }
    });
  },[openProj])
  const [selectedProjForCampaign, setSelectedProj] = useState([]);
  const [memberUserDetail, setMemberUser] = useState([]);
  const [memberRoles, setMemberRoles] = useState([]);
  const [showProgressBtn, togglePrgressBtn] = useState(false);
  const [activeTab, setActiveSection] = useState("overView");
  const [campaignData, setCampaignData] = useState();
  const [reviewerData,setReviewerData] =useState(null)
  const [projectListing,setProjectListing]=useState(null)
  const [projectStatus,setProjectStatus]=useState([])
  const [refreshProjectData,setRefreshProjectData]=useState("")
  const [campaignDataStatus,setCampaignDataStatus]=useState(false)
  const navigateBack = () => {
    navigate("/campaigns");
  };
  const editCampaign = () =>{
    hideModel()
    navigate(`/campaign-edit/${param.id}`);
  }
  const showHide = (e) => {
    if (e.key === "Enter" || e.type === "click") {
      showProgressBtn ? togglePrgressBtn(false) : togglePrgressBtn(true);
    }
    if (e.type==="click" || e.key===Constants.ENTER ||
    (e.key===Constants.ESCAPE && $('#selectTaskType').attr('aria-expanded') === "true") ||
    (e.key===Constants.TAB && $('#selectTaskType').attr('aria-expanded') === "true")) {
      $('#selectTaskType').attr('aria-expanded', function(_, attr) {
        return attr === 'false' ? 'true' : 'false';
      }); 
    }
  };

useEffect(()=>{
if(activityTaskId !==""){
  setActiveSection("tasks")
}
},[activityTaskId])

  const addExistingProjectsToCampaign = () => {
    
    postAxiosResponse(APIUrls.UPDATE_CAMPAIGN_PROJECT_LIST(param.id),selectedProjForCampaign)
    .then((res) => {
      if (res.data.status === "success") {
        hideProjectModel()
       setProjectListing(projectListing+1)
       setActiveSection("projects")
       getCampaign()
       getProjectCount()
      }
    })
    .catch((err) => {
      handleError(err);
    });
    
  };
  const cancelCampaign = () => {
    var cancelPayload = transformBlankToNull(campaignData?.workspace)
    var cancelCampaignReq = {
     status :  "CANCELLED",
     id : cancelPayload.id
    }
    putAxiosResponse(APIUrls.CANCEL_CAMPAIGN(param.id),cancelCampaignReq).then((res)=>{
     console.error('cancel response : ',res)
    });
  }
  useEffect(() => {
    getCampaign()
    getAxiosResponse(APIUrls.CAMPAIGN_MEMBER_USER(param.id))
      .then((res) => {
        if (res.data !== "") {
          setMemberUser(res.data.data);
        }
        //setMemberRoles(roles)
      })
      .catch((err) => {
        handleError(err);
      }).catch(err=>{
        console.error(err)
      })
      getProjectCount()
  }, []);

  const getProjectCount=()=>{
    getAxiosResponse(APIUrls.CAMPAIGN_PROJECT_STATUS(param.id))
    .then((res) => {
      if (res.data !== "") {
        var localCount=0;
        let countData=res?.data?.data
        if(countData !==undefined){
        setProjectStatus(countData);
        Object.keys(countData?.model)?.map((item, i) => {
          setProjectCount(localCount +=countData?.model[item])
        })
      }
      }
    }).catch(err=>{
      console.error(err)
    })
  }
  const toggleProgBtn = () => {
    if (showProgressBtn) {
      $("#progress-btn").css("opacity", 1);
      $("#progress-btn").css("visibility", "visible");
    } else {
      $("#progress-btn").css("opacity", 0);
      $("#progress-btn").css("visibility", "hidden");
    }
  };
const setFocus = (event) =>{
  $('#campaignDetailClose').trigger('focus')
}
  useEffect(() => {
    toggleProgBtn();
  }, [showProgressBtn]);
  const handleEscapeInPopup = (event) => {
    let key=event?.key
    if(key !==undefined && key !==null) {
      if (key === "Escape" && reference1?.current?.contains(event?.target) || (key === "Escape" && $('.circle').is(':focus'))) {
        togglePrgressBtn(false);
        $("#progress-btn").css("opacity", 0);
        $("#progress-btn").css("visibility", "hidden");
        $('.circle').trigger('focus');
      }
    }
  };
  const handleClickOutsidePopup = (event) => {
    if (
      reference1.current &&
      !reference1.current.contains(event.target) &&
      reference2.current &&
      !reference2.current.contains(event.target)
    ) {
      togglePrgressBtn(false);
      $("#progress-btn").css("opacity", 0);
      $("#progress-btn").css("visibility", "hidden");
    }
    if ($('#selectTaskType').attr('aria-expanded') === "true") {
      $('#selectTaskType').attr('aria-expanded', 'false');
    }
  };
  const handleFocusOutsidePopup = (event) => {
    if (reference1.current && !reference1.current.contains(event.target)) {
      togglePrgressBtn(false);
      $("#progress-btn").css("opacity", 0);
      $("#progress-btn").css("visibility", "hidden");
    }
  };
  const getSelectedProjectList = (data) => {
    var ids = [];
    var rowsData = data.selectedRows
   if( rowsData.length !== 0 ){
    rowsData.map((row)=>{
      ids.push(row.id)
    })
   }
   var postData = {
    "projectIdsToAdd": ids,
  }
    setSelectedProj(postData);
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutsidePopup, true);
    document.addEventListener("focus", handleFocusOutsidePopup, true);
    document.addEventListener("keydown", handleEscapeInPopup, true);
    return () => {
      document.removeEventListener("click", handleClickOutsidePopup, true);
      document.removeEventListener("focus", handleFocusOutsidePopup, true);
      document.removeEventListener("keydown", handleEscapeInPopup, true);
    };
  }, [reference1, reference2]);
  useEffect(()=>{
if(param.tab && param.tabDetailId){
  setActiveSection("tasks")
}
if(state !== null && state.id){
  setTaskId(state.id)
  setActiveSection("tasks")
}
  },[state])

  const getCampaign=()=>{
    getAxiosResponse(APIUrls.CAMPAIGN_DETAIL(param.id))
      .then((res) => {
        let campaign=res?.data?.data;
        if (campaign !==undefined) {
          setCampaignData(res.data.data);
          setCampaignDataStatus(false);
          const count = campaign?.resource?.tabs?.filter((t)=>t?.display ==="Discussions")[0].count;
          setCount(count);
        }else{
          setCampaignData({message:res?.data?.handledMessage})
          setCampaignDataStatus(true)
        }
      })
      .catch((err) => {
        handleError(err);
      });
  }

  useEffect(()=>{
		$(".lastdisable").trigger("focus");
	}, [])

  const getIntendedUseAndTriggerProjectCreation =() =>{
    getAxiosResponse(APIUrls.DEPARTMENT_INCLUDE_SYSTEM_IF_POPULATED)
    .then((res) => {        
      if (res.data.data && res.data.data.length > 0) {                   
        department= getDepartmentObject(res.data.data);
        getIntendedUseForProjectCreation();        
      }
    })
    .catch((err) => {
      handleError(err);
    })
    
  }
  const closeCampaign = () => {
    var cancelPayload = transformBlankToNull(campaignData?.workspace)
    var cancelCampaignReq = {
     status :  "CLOSED",
     id : cancelPayload.id
    }
    setTimeout(() => {
      $("#react-confirm-alert").attr({
        'aria-modal': 'true',
        'role': 'dialog',
        'aria-labelledby':"deleteUploadfile"
        });
        $("h1").attr({
        'id': 'deleteUploadfile',
       });
      }, 200);
    setTimeout(() => {
      $('#accept-delete-source-material').trigger('focus');
      $(".react-confirm-alert-overlay").on("keydown", function (e) {
        if (e.key === Constants.ESCAPE) {
          if($("button").hasClass("focusAdd")){
            $('.focusAdd').trigger('focus')
          }
        }
        });
    }, 500);
     
    confirmAlert({
      title: `${t("Close Campaign")}`,
      message: (
        <p>{`${t("This will close this campaign. This action cannot be reversed. Once the campaign has been closed, you cannot add new projects.")}`}</p>
      ),
      buttons: [
        {
          label: `${t('button_accept')}`,
          id: 'accept-delete-source-material',
          onClick: () => putAxiosResponse(APIUrls.CANCEL_CAMPAIGN(param.id),cancelCampaignReq).then((res)=>{
            console.error('cancel response : ',res)
            getCampaign()
           }),
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === true){
                e.preventDefault()
                $('#cancel-delete-source-material').trigger('focus');
              }
            }
          }
        },
        {
          label: `${t('button_cancel')}`,
          id: 'cancel-delete-source-material',
          onClick: () => {
            setTimeout(() => {
              $('.focusAdd').trigger('focus');
              $('.delete-icon').removeClass('focusAdd');
            }, 200);
            
          },
          onKeyDown : (e) => {
            if(e.key === Constants.TAB){
              if(e.shiftKey === false){
                e.preventDefault()
                $('#accept-delete-source-material').trigger('focus');
              }
            }
          }
        },
      ],
      closeOnEscape: true,
      closeOnClickOutside: false,
      overlayClassName: "delete_overlay",
    });
  };
  const getIntendedUseForProjectCreation =() =>{
    getAxiosResponse(APIUrls.INTENDED_USE).then((res) => {
      if (res.data.code === 200) {
        const minimumIntendedUseId = Math.max(...res.data.data.map(x=>x.id))
        intendedUseId = minimumIntendedUseId;
        triggerProjectCreation();
      }
     }).catch(err=>{
      console.error(err)
    })
  }

  const triggerProjectCreation = () =>{
    dispatch(updateSourceFiles([]));
    dispatch(updateAsyncUploadAssetPendingFiles({}))
    dispatch(updateAsyncUploadAssetCompletedFiles([]))
    dispatch(updateAsyncUploadAssetInProgressFiles([]))
    dispatch(updateValidationErrors([]))
    dispatch(updateReadyForValidation(false));
    dispatch(updateCanSubmitTranslation(true));
    dispatch(updateBidRequestInfo({}));
    postAxiosResponse(APIUrls.CREATE_PROJECT,{"status":"CONFIGURED_BASIC_PROJECT_INFO",
    "projectFollowers":null,
    "name":"-----",
    "intendedUse": {
            "id": intendedUseId
        },
        "workspace": {
          "id": param.id
      },
        "userGroup":department
        })
        .then((res) => {
  
            const projectId = res.data.data.id;
            let projectResource = transformBlankToNull(res.data.data);
            //deleted  this key as it was giving 400 
            delete projectResource["owner"];
            delete projectResource["projectFollowers"];    
            if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
              delete projectResource["workspace"]['workspaceMembers'];
            }          
            projectResource.name=`Project-${projectId}`;
            projectResource.intendedUse = {"id":projectResource.intendedUse.id};
            projectResource.targetLanguages = []
            putAxiosResponse(APIUrls.PROJECT(projectId), projectResource).then((res)=>{
              dispatch(projectCreationStepFilter("Source Material Step 1"))               
              dispatch(updateSourceLanguage({}));	
              dispatch(updateTargetLanguage([]));	   
              dispatch(departmentSelected(""));
              dispatch(updateProjectFollowers([]));
              dispatch(updateInitializedProjectWorkflows([]));
              dispatch(updateProjectInfoValidation({}));
              dispatch(updateProjectInfoConfiguration({}));
              dispatch(updateProjectInfo({}));
              navigate(`/createProject/${projectId}`);
            });
            
        })
        .catch((err) => {
          console.error("Error post request");
        });
      
   }

//Tutorial Tips start
function doArrow(position, verticalAlign, horizontalAlign) {
  if (!position) {
    return {};
  }
 const width = 16;
  const height = 12;
  const color = "white";
  const isVertical = position === "top" || position === "bottom";
  const spaceFromSide = 10;

  const obj = {
    [`--rtp-arrow-${
      isVertical ? opositeSide[horizontalAlign] : verticalAlign
    }`]: height + spaceFromSide + "px",
    [`--rtp-arrow-${opositeSide[position]}`]: -height + 2 + "px",
    [`--rtp-arrow-border-${isVertical ? "left" : "top"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${isVertical ? "right" : "bottom"}`]: `${
      width / 2
    }px solid transparent`,
    [`--rtp-arrow-border-${position}`]: `${height}px solid ${color}`
  };
  return obj;
}
const popupHandling = (event) => {
  if(event.key===Constants.ESCAPE) {
    hideModel();
  }
  $('#campaignDetailClose').on('keydown', function(e){
    if(e.key===Constants.TAB) {
      e.preventDefault();
      $('#editCampaigndetail').trigger('focus');
    }
  });
  $('#editCampaigndetail').on('keydown', function(e){
    if(e.key===Constants.TAB) {
      e.preventDefault();
      $('#campaignDetailClose').trigger('focus');
    }
  });
}

useEffect(()=>{
if(refreshProjectData !=="" || projectDeliveryStatus !==""){
  setActiveSection("projects");
  setTimeout(() => {
    $('.listing-tab-link li button.active').trigger('focus');
  }, 300);
}
},[refreshProjectData,projectDeliveryStatus])


const styles = {
  popover: (base, state) => {
   return {
      ...base,
     ...doArrow(state.position, state.verticalAlign, state.horizontalAlign),
     '--reactour-accent': '#154da1',
     };
  }
  
};
const opositeSide = {
  top: "bottom",
  bottom: "top",
  right: "left",
  left: "right"
};
const prevButton= ({ currentStep, setCurrentStep, steps }) => {
  const first = currentStep === 0
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <button aria-label="go to previous" disabled={first ? "disabled" : ""} className={first ? "tutorial-left-arr tutorial-disable" : "tutorial-left-arr"}
      onClick={() => {
        if (first) {
          setCurrentStep((s) => steps.length - 1)
        } else {
          setCurrentStep((s) => s - 1)
        }
      }}
    >
      <svg viewBox="0 0 18.4 14.4"><path d="M1.4 7.2h16M7.6 1L1.4 7.2l6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
    </button>
  )
 };
 const nextButton= ({ currentStep, setCurrentStep, steps, stepsLength, setIsOpen }) => {
  const last = currentStep === stepsLength - 1
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).trigger('focus')
  $(`.tutorial-left-arr + div button`).each(
    function(index, item){
      $(item).attr('aria-label','Go to step ' + (index + 1))
    }
  )
  $(`.tutorial-left-arr + div button:nth-child(${currentStep + 1})`).attr('aria-label','current step '+ (parseInt(currentStep,10) + 1))
  return (
    <>
    {last ? (
      <button className="finish-btn"
        onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >Finish</button>
    ) : (
      <button aria-label="go to next" disabled={last ? "disabled" : ""} className={last ? "tutorial-right-arr tutorial-disable" : "tutorial-right-arr"}
      onClick={() => {
        if (last) {
          setIsOpen(false)
        } else {
          setCurrentStep((s) => (s === steps?.length - 1 ? 0 : s + 1))
        }
       }}
      >
      <svg viewBox="0 0 18.4 14.4"><path d="M17 7.2H1M10.8 1L17 7.2l-6.2 6.2" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-miterlimit="10"></path></svg>
      </button>
    )}
    </>
  )

 }
const disableBody = (target) => disableBodyScroll(target)
const enableBody = (target) => enableBodyScroll(target)
const CampaignModelTutorial = () =>{
 document.body.classList.add("modal-open-4");
 $(".nextFocus4").on("keydown", function (e) {
  if (e.key === Constants.TAB) {
    if (e.shiftKey === false) {
      e.preventDefault();
      $(".cancelFocus4").trigger("focus");
    }
  }
});
setTimeout(() => {
  $(".cancelFocus4").trigger("focus");
  $(".cancelFocus4").on("keydown", function (e) {
    if (e.key === Constants.TAB) {
      if (e.shiftKey === true) {
        e.preventDefault();
        $(".nextFocus4").trigger("focus");
      }
    }
  });
  $(".inner-lightbox-panel").on("keydown", function (e) {
    if (e.key === Constants.ESCAPE) {
      document.body.classList.remove("modal-open-4");
      $('.focusAdd').trigger('focus');
      $('.tutorial-tips').removeClass('focusAdd');
    }
  });
}, 500);
}
//Tutorial Tips end
const crumbs = [
  {label:'Campaigns', url:'campaigns'},
  {label:'Campaign', url:''}
];

  const decreaseMessageCount = () => {
    if (unreadDiscussionCount > 0) {
      setCount(unreadDiscussionCount - 1);
    }
  }


  return (
    <div className="body bg-color">
      <div id="container" className="dashboard-wrapper">
      <TourProvider
          steps={steps}
          styles={styles}
          prevButton={prevButton}
          nextButton={nextButton}
          afterOpen={disableBody}
          beforeClose={enableBody}
          onClickMask={({ currentStep, steps, setIsOpen }) => {
            if (steps) {
              if (currentStep === steps.length) {
                setIsOpen(true);
               }
              }
          }}
          badgeContent={({ totalSteps, currentStep }) => currentStep + 1 + "/" + totalSteps}>
          <Header ref={scrollRef} func={CampaignModelTutorial}/>
          <LeftNavbar />
        </TourProvider>
        <section className="dashboard-content" ref={scrollRef} >
          <div id="content" className="dashboard-wrap campaign-section">
            <Breadcrumb crumbs={ crumbs } />
            {!campaignDataStatus?
            <div className="wrap-data">
              <div className="white-bg campaign-page">
                <div className="name-card-section">
                  <div className="name-card-section-left">
                    <div className="campaign-name">
                      <button
                        onClick={navigateBack}
                        className="back-btn"
                        aria-label="back"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14"
                          height="13"
                          viewBox="0 0 14 13"
                          fill="none"
                        >
                          <path
                            d="M0.46967 5.96967C0.176777 6.26256 0.176777 6.73744 0.46967 7.03033L5.24264 11.8033C5.53553 12.0962 6.01041 12.0962 6.3033 11.8033C6.59619 11.5104 6.59619 11.0355 6.3033 10.7426L2.06066 6.5L6.3033 2.25736C6.59619 1.96447 6.59619 1.48959 6.3033 1.1967C6.01041 0.903806 5.53553 0.903806 5.24264 1.1967L0.46967 5.96967ZM1 7.25H14V5.75H1V7.25Z"
                            fill="#4D4D4D"
                          />
                        </svg>
                      </button>
                      <h3>{campaignData?.workspace?.name}</h3>
                      <button onClick={editCampaign} aria-label="Edit" className="name-edit" campaigndetail-tour="edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                      </button>
                    </div>
                    <p>
                      {projectCount > 1
                        ? "Total Projects -"
                        : "Total Project -"}{" "}
                      <strong>
                        {
                          projectCount
                        }
                      </strong>
                    </p>
                  </div>
                  <div className="name-card-section-right">
                    <div className="progress readonly" tabIndex="-1">
                      {campaignData?.workspace?.status?.replace(/_/g, " ")}
                    </div>
                    {(campaignData?.workspace?.status !=="CANCELLED" && campaignData?.workspace?.status !=="CLOSED") && campaignData?.workspace?.editableByContextUser ?
                   <>
                   <div
                      id="selectTaskType"
                      className="circle"
                      onClick={(e) => showHide(e)}
                      onKeyDown={(e) => showHide(e)}
                      role="button"
                      aria-label="Task Type"
                      aria-expanded="false"
                      tabIndex="0"
                      ref={reference2}
                      campaigndetail-tour="add-project"
                    >
                      <div className="dots">
                        <span></span>
                        <span></span>
                        <span></span>
                        <div className="triangle-with-shadow"></div>
                      </div>
                    </div>
                    <div
                      className="progress-btn"
                      id="progress-btn"
                      ref={reference1}
                    >
                      <div className="inner-popover">
                        <button className="dashboard-btn"
                        onClick={() => {
                          getIntendedUseAndTriggerProjectCreation();
                        }}>
                          <svg
                            className="plus-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6 1V11"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M1 6H11"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                          {translate("campaign_page.add_new_projects")}
                        </button>
                        <button
                          className="dashboard-btn"
                          onClick={() => {
                            openAddProjPopup();
                          }}
                        >
                          <svg
                            className="plus-icon"
                            xmlns="http://www.w3.org/2000/svg"
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                          >
                            <path
                              d="M6 1V11"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                            <path
                              d="M1 6H11"
                              stroke="#1D4ED8"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            ></path>
                          </svg>
                          {translate("campaign_page.add_existing_project")}
                        </button>
                        <ConditionalBlock condition={campaignData?.workspace?.status ==="COMPLETED"}>
                        <button className="dashboard-btn" onClick={closeCampaign}>
                         {translate("campaign_page.close_campaign")}
                        </button>
                          </ConditionalBlock>
                          <ConditionalBlock condition={campaignData?.workspace?.status !=="COMPLETED"}>
                        <button className="dashboard-btn" onClick={cancelCampaign}>
                         {translate("campaign_page.cancel_campaign")}
                        </button>
                          </ConditionalBlock>
                      </div>
                    </div></> : Constants.BLANK}
                  </div>
                </div>
                <div className="listing-tab-block flex">
                  <ul className="listing-tab-link flex" role="tablist">
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Overview') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "overView" ? "Current tab " + translate("campaign_page.overview") : translate("campaign_page.overview")}
                        aria-selected={activeTab === "overView" ? "true" : "false"} role="tab"
                        className={activeTab === "overView" ? "active" : ""}
                        onClick={() => setActiveSection("overView")}
                      >
                        {translate("campaign_page.overview")}
                      </button>
                    </li>:Constants.BLANK}
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Reviewers') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "reviewers" ? "Current tab " + translate("campaign_page.reviewers") : translate("campaign_page.reviewers")}
                        aria-selected={activeTab === "reviewers" ? "true" : "false"} role="tab"
                        className={activeTab === "reviewers" ? "active" : ""}
                        onClick={() => setActiveSection("reviewers")}
                        campaigndetail-tour="reviewer-tab"
                      >
                        {translate("campaign_page.reviewers")}
                      </button>
                    </li>:Constants.BLANK}
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Projects') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "projects" ? "Current tab " + translate("campaign_page.projects") : translate("campaign_page.projects")}
                        aria-selected={activeTab === "projects" ? "true" : "false"} role="tab"
                        className={activeTab === "projects" ? "active" : ""}
                        onClick={() => setActiveSection("projects")}
                      >
                      {translate("campaign_page.projects")}
                      </button>
                    </li>:Constants.BLANK}
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Tasks') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "tasks" ? "Current tab " + translate("campaign_page.tasks") : translate("campaign_page.tasks")}
                        aria-selected={activeTab === "tasks" ? "true" : "false"} role="tab"
                        className={activeTab === "tasks" ? "active" : ""}
                        onClick={() => setActiveSection("tasks")}
                        campaigndetail-tour="task-tab"
                      >
                      {translate("campaign_page.tasks")}
                      </button>
                    </li>:Constants.BLANK}
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Assets') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "assets" ? "Current tab " + translate("campaign_page.assets") : translate("campaign_page.assets")}
                        aria-selected={activeTab === "assets" ? "true" : "false"} role="tab"
                        className={activeTab === "assets" ? "active" : ""}
                        onClick={() => setActiveSection("assets")}
                      >
                                                {translate("campaign_page.assets")}

                      </button>
                    </li>:Constants.BLANK}
                    {campaignData?.tabs && campaignData?.tabs?.length > 0  && campaignData?.tabs?.findIndex(data=>data?.display==='Discussions') !== -1 ?
                    <li role="none">
                      <button
                        aria-label={activeTab === "discussions" ? "Current tab " + translate("campaign_page.discussions") : translate("campaign_page.discussions")}
                        aria-selected={activeTab === "discussions" ? "true" : "false"} role="tab"
                        className={activeTab === "discussions" ? "active" : ""}
                         onClick={() => setActiveSection("discussions")}
                      >
                        {translate("campaign_page.discussions")}
                        {unreadDiscussionCount>0?<span>{unreadDiscussionCount}</span>:''}
                      </button>
                    </li>:Constants.BLANK}
                  </ul>
                </div>

                {campaignData !== undefined
                  ? (() => {
                      switch (activeTab) {
                        case "overView":
                          return (
                            <Overview
                              data={campaignData?.workspace}
                              totalProject={
                                campaignData?.workspace?.projectSummaryInfo
                                  ?.totalProjects
                              }
                              setReviewer={setReviewerData}
                              setTab={setActiveSection}
                              setRefreshProject={setRefreshProjectData}
                              setProjectDileveryStatus={setProjectDileveryStatus}
                              projectStatus={projectStatus}
                              setTaskId={setTaskId}
                            />
                          );
                        case "reviewers":
                          return <Reviewers />;
                        case "projects":
                          return <Projects editableByContextUser={campaignData?.workspace?.editableByContextUser}  projectDeliveryStatusData={projectDeliveryStatus} refreshList={projectListing} refreshProjectData={refreshProjectData}  refreshProject={getCampaign}/>;
                        case "tasks":
                          return <Tasks  activityTaskId={activityTaskId} campaignWorkspace={campaignData?.workspace} filterData={reviewerData} taskId={param?.tabDetailId}/>;
                        case "assets":
                          return <Assets />;

                          case "discussions":
                            return <Discussion decreaseMessageCount={decreaseMessageCount} data={campaignData?.workspace} />;
                           
                        default:
                          return "";
                      }
                    })()
                  : ""}
              </div>
              {!openProj && activeTab !== 'projects' ? (
                <div id="modelPopup" className="lightbox-panel" >
                  <div className="inner-lightbox-panel popup-inner"
                    onKeyDown={(e)=>popupHandling(e)}
                    aria-labelledby="campaignDetailModal"
                    aria-modal="true"
                    role="dialog"
                  >
                    <div className="modal-header flex popup-header" >
                      <h5 id="campaignDetailModal">{translate("campaign_page.campaign_details")}</h5>
                      <button
                        className="close"
                        aria-label="close"
                        onClick={hideModel}
                        id="campaignDetailClose"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                        >
                          <path
                            d="M17.9242 17.9242C15.94 19.9085 13.3062 21 10.5 21C7.69381 21 5.05997 19.9085 3.07576 17.9242C1.09154 15.94 0 13.3062 0 10.5C0 7.69381 1.09154 5.05997 3.07576 3.07576C5.05997 1.09154 7.69381 0 10.5 0C13.3062 0 15.94 1.09154 17.9242 3.07576C19.9085 5.05997 21 7.69381 21 10.5C21 13.3062 19.9085 15.94 17.9242 17.9242ZM17.0802 3.91982C15.3213 2.16098 12.9836 1.19318 10.5 1.19318C8.01641 1.19318 5.67866 2.16098 3.91982 3.91982C0.291667 7.54798 0.291667 13.452 3.91982 17.0802C5.67866 18.839 8.01641 19.8068 10.5 19.8068C12.9836 19.8068 15.3213 18.839 17.0802 17.0802C20.7083 13.452 20.7083 7.54798 17.0802 3.91982Z"
                            fill="white"
                          ></path>
                          <path
                            d="M15.1267 15.1269C14.8925 15.3611 14.5169 15.3611 14.2827 15.1269L10.4998 11.3441L6.71699 15.1269C6.48278 15.3611 6.10715 15.3611 5.87293 15.1269C5.63871 14.8927 5.63871 14.517 5.87293 14.2828L9.65576 10.5L5.87293 6.71716C5.63871 6.48295 5.63871 6.10732 5.87293 5.8731C5.98783 5.7582 6.1425 5.69633 6.29275 5.69633C6.443 5.69633 6.59768 5.75378 6.71257 5.8731L10.4954 9.65593L14.2782 5.8731C14.3931 5.7582 14.5478 5.69633 14.6981 5.69633C14.8527 5.69633 15.003 5.75378 15.1179 5.8731C15.3521 6.10732 15.3521 6.48295 15.1179 6.71716L11.3439 10.5L15.1267 14.2828C15.3609 14.517 15.3609 14.8927 15.1267 15.1269Z"
                            fill="white"
                          ></path>
                        </svg>
                      </button>
                    </div>
                    <div className="lightbox-content popup-content">
                      <div className="popup-content-left">
                        <h5 className="sub-head" id="campaignDetails" ref={campaignDetailRef}>{translate("campaign_page.campaign_details")}
                      </h5>
                        <table className="campaign_details-table" aria-describedby="campaignDetails">
                          <tbody>
                            <tr>
                              <th scope="row" className="head ellipsis-text">
                                <span>{translate("campaign_page.campaign_owner")}</span>
                              </th>
                              <td className="text">
                                {campaignData?.workspace?.owner?.firstName +
                                  " " +
                                  campaignData?.workspace?.owner?.lastName}
                                     {/* <button id="editCampaigndetail" onClick={editCampaign} aria-label="Edit" className="name-edit" campaigndetail-tour="edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                      </button> */}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" className="head ellipsis-text">
                                <span>Campaign Id</span>
                              </th>
                              <td className="text">
                                {
                                  campaignData?.workspace?.id}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" className="head ellipsis-text">
                                <span>{translate("campaign_page.campaign_created")}</span>
                              </th>
                              <td className="text">
                                {
                                  campaignData?.workspace?.createdDate?.dateWithTime
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" className="head ellipsis-text">
                                <span>{translate("campaign_page.campaign_due_date")}</span>
                              </th>
                              <td className="text">
                                {
                                  campaignData?.workspace?.dueDate?.dateWithTime
                                }
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" className="head ellipsis-text"> 
                                <span>{translate("campaign_page.campaign_tags")}</span>
                              </th>
                              <td className="text" >
                                {campaignData?.workspace?.tags && campaignData?.workspace?.tags?.length === 0 ? (
                                  <span tabIndex={0}>No tags selected</span>
                                ) : (
                                  <ul>
                                    {campaignData?.workspace?.tags && campaignData?.workspace?.tags?.length > 0 && campaignData?.workspace?.tags.map(
                                      (tags, index) => {
                                        return (
                                          <li
                                            key={index}
                                            style={{
                                              // display: "inline",
                                              // padding: "3px",
                                              // background: "#f1f1f1",
                                              // marginRight: "3px",
                                              // borderRadius: "2px",
                                            }}
                                          >
                                            {tags}
                                          </li>
                                        );
                                      }
                                    )}
                                  </ul>
                                )}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row" className="head">
                                <span>{translate("campaign_page.campaign_description")}</span>
                              </th>
                              <td className="text">
                                {campaignData?.workspace?.description}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div className="popup-content-right">
                        <table className="campaign_details-table" aria-label="member list">
                          <thead>
                            <tr>
                              <th className="sub-head">{translate("campaign_page.member_list")}
                              {/* <button id="editCampaigndetail" onClick={editCampaign} aria-label="Edit" className="name-edit" campaigndetail-tour="edit">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="17"
                          height="16"
                          viewBox="0 0 17 16"
                          fill="none"
                        >
                          <path
                            d="M0.25 15.25H17.75V16.5H0.25V15.25ZM14.875 4.625C15.375 4.125 15.375 3.375 14.875 2.875L12.625 0.625C12.125 0.125 11.375 0.125 10.875 0.625L1.5 10V14H5.5L14.875 4.625ZM11.75 1.5L14 3.75L12.125 5.625L9.875 3.375L11.75 1.5ZM2.75 12.75V10.5L9 4.25L11.25 6.5L5 12.75H2.75Z"
                            fill="#1D4ED8"
                          />
                        </svg>
                      </button> */}
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {memberUserDetail?.map((member, index) => {
                              return (
                                <tr key={index}>
                                  <td className="head ellipsis-text" onKeyDown={index === memberUserDetail.length - 1 ? (event)=>setFocus(event) : null}>
                                    <span>
                                      {member.resource?.firstName +
                                        " " +
                                        member.resource?.lastName}{" "}
                                      {"(" +
                                        member.displayName[0][0].replace(
                                          ", ",
                                          ") ("
                                        ) +
                                        ")"}
                                    </span>
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div
                  className={
                    openProj ? "lightbox-panel show" : "lightbox-panel hide"
                  }
                >
                  <div className="inner-lightbox-panel popup-inner" onKeyDown={(e)=>{existingProjectPopupHandling(e)}}
                    aria-labelledby="existingProject"
                    aria-modal="true"
                    role="dialog"
                  >
                    <div className="modal-header flex popup-header">
                      <h5 id="existingProject">
                        Add Existing Project To {campaignData?.workspace?.name}
                      </h5>
                      <button
                        id="ExistingProjectclosebtn"
                        className="close"
                        aria-label="close"
                        onClick={hideProjectModel}
                      >
                        {CrossIconForModal}
                      </button>
                    </div>
                    <div className="popup-content filterSpace revert-overflow">
                      <AddExistingProjectToCampaign
                        workspaceId={param.id}
                        func={getSelectedProjectList}
                      />
                    </div>
                    <div className="modal-footer popup-footer">
                      <div className="btn-wrap flex-center">
                        <div className="btn-right">
                          <button
                            className={
                              selectedProjForCampaign.length === 0
                                ? "btn-default btn-disable"
                                : "btn-default"
                            }
                            disabled={selectedProjForCampaign?.projectIdsToAdd?.length === 0}
                            onClick={addExistingProjectsToCampaign}
                          >
                            Add and Save
                          </button>
                          <button id="cancelAddExistingProjectBtn" className="btn" onClick={hideProjectModel}>
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>:
                  <UnableToCompleteRequest message={campaignData?.message} />
                          }
          </div>
        </section>
      </div>
    </div>
  );
}
